import { CircularProgress } from '@mui/material';
import { getObjectListApi } from 'api/general';
import AnnouncementDataTable from 'app/components/DataTable/announcement/AnnouncementDataTable';
import UnitDataTable from 'app/components/DataTable/unit/UnitDataTable';
import LoadingPopUp from 'app/components/LoadingPopup';
import { sortByDate } from 'app/utils/appHelpers';
import { ANNOUNCEMENT } from 'app/utils/constants/customConstant';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';


const ListAnnouncement = () => {


    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const allAnnouncements = useSelector(state => state.general.announcements);
    const allAuthorizedInsts = useSelector(state => state.auth.allAuthorizedInsts);

    useEffect(() => {
        const getAPI = async () => {
            setLoading(true);

            let data = allAnnouncements;
            data = sortByDate(data, "addedDate", "desc")

            if (allAuthorizedInsts.length > 0) {
                data = data.filter(x => {
                    const toAnnouncementArray = x.toAnnouncement ? x.toAnnouncement.split(',').map(item => item.trim()) : [];

                    return toAnnouncementArray.some(inst => allAuthorizedInsts.includes(inst));
                });
            }
            setData(data);
            setLoading(false);
        }
        getAPI()
    }, [])




    const columnData = [

        { id: 'user', align: 'center', disablePadding: false, label: "Kullanıcı" },
        { id: 'toAnnouncement', align: 'center', disablePadding: false, label: "İlgili Kurumlar" },
        { id: 'title', align: 'center', disablePadding: false, label: "Duyuru Başlığı" },

        { id: 'status', align: 'center', disablePadding: false, label: "Durum" },
        { id: 'addedDate', align: 'center', disablePadding: false, label: "Tarih" },
        { id: 'islemler', align: 'center', disablePadding: false, label: "İşlemler" }
    ];


    return (
        <React.Fragment>

            <>
                <LoadingPopUp open={loading} />
                {!loading && <AnnouncementDataTable mainData={data} column={columnData} pageTitle="Duyuru Listesi" />}
            </>



        </React.Fragment>
    );
};

export default ListAnnouncement;